/*
 * File: SF.service.ts
 * Project: a-a
 * File Created: Wednesday, 5th March 2025 11:23:56 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 18th July 2025 1:18:57 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import axios from '../core/axios';

import { ApiConstants } from './api-constants';

export class SFService {
  static getSFToken = async (code: string) => {
    return await (
      await axios.get(ApiConstants.SF_API.GET_SF_TOKEN.URL(code))
    ).data;
  };
  static getOptions = async (email: string) => {
    return await (
      await axios.get(ApiConstants.SF_API.GET_DROPDOWN.URL(email))
    ).data;
  };
  static getProfileDetails = async (email: string) => {
    return await (
      await axios.get(ApiConstants.SF_API.GET_PROFILE_DETAILS.URL(email))
    ).data;
  };
  static createTasks = async (data: any) => {
    return await (
      await axios.post(ApiConstants.SF_API.SF_TASK.URL(), data)
    ).data;
  };
  static editTask = async (id: string, data: any) => {
    return await (
      await axios.patch(ApiConstants.SF_API.EDIT_SF_TASK.URL(id), data)
    ).data;
  };
  static deleteTask = async (id: string) => {
    return await (
      await axios.delete(ApiConstants.SF_API.DELETE_SF_TASK.URL(id))
    ).data;
  };
  static getPresigned = async (mail: string, type: string, key: string) => {
    return await (
      await axios.get(ApiConstants.SF_API.GET_PRESIGNED_URL.URL(mail, type, key))
    ).data;
  };
  static uploadFile = async (data: any, contentType: string) => {
    return await (
      await axios.post(
        ApiConstants.SF_API.S3_UPLOAD.URL(),
        { ...data },
        {
          headers: {
            'Content-Type': 'multipart/form-data', // Important to set this header
          },
        },
      )
    ).data;
  };
}
